/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationSettingsResponse } from '../../models/location-settings-response';
import { LocationSettingsUpdateRequest } from '../../models/location-settings-update-request';

export interface UpdateLocationSettings$Params {
  location_id: string;
  
    /**
     * New metadata
     */
    body: LocationSettingsUpdateRequest
}

export function updateLocationSettings(http: HttpClient, rootUrl: string, params: UpdateLocationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<LocationSettingsResponse>> {
  const rb = new RequestBuilder(rootUrl, updateLocationSettings.PATH, 'put');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LocationSettingsResponse>;
    })
  );
}

updateLocationSettings.PATH = '/locations/{location_id}/settings';
